// Perfect Sound for Every Moment
// Leisure
let Leisure_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Leisure type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// Travel
let Travel_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Travel type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// Fitness
let Fitness_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ajuste y comodidad',
      content: 'Busca diseños ergonómicos que proporcionen un ajuste perfecto, como ganchos para la oreja o auriculares internos, para garantizar que se mantengan en su lugar durante el movimiento intenso.',
    },
    {
      id: 2,
      product: '',
      title: 'Estabilidad del ajuste',
      content: 'Los auriculares deben permanecer firmemente en su lugar, especialmente durante actividades de alta intensidad como correr, lo que evita que tengas que ajustarlos constantemente.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Resistencia al sudor y al agua',
      content: 'Elige auriculares con al menos una clasificación IPX4 para garantizar que resistan el sudor y la humedad.',
    },
    {
      id: 2,
      product: '',
      title: 'Durabilidad',
      content: 'Elige auriculares con una estructura resistente que sea resistente a caídas y rayones, lo que garantiza un rendimiento duradero, especialmente en exteriores o entornos de alto impacto.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Duración de la batería',
      content: "Opta por modelos con batería de larga duración si te ejercitas durante períodos prolongados, idealmente más de 8 horas.",
    },
    {
      id: 2,
      product: '',
      title: 'Eficiencia de carga',
      content: 'Algunos auriculares ofrecen carga rápida, que puede proporcionar varias horas de uso en solo unos minutos, lo que resulta beneficioso para usuarios frecuentes.',
    },
    {
      id: 3,
      product: '',
      title: 'Características de control',
      content: 'Los controles en el dispositivo fáciles de usar o los asistentes de voz pueden facilitar el ajuste de la música o la recepción de llamadas sin interrumpir el entrenamiento.',
    },
    {
      id: 4,
      product: '',
      title: 'Funciones inteligentes',
      content: 'Las funciones como los asistentes de voz o las configuraciones de audio adaptativas minimizan los ajustes manuales, lo que permite a los usuarios concentrarse más en su entrenamiento.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Calidad de sonido',
      content: 'El sonido claro con graves potentes puede mejorar su experiencia de entrenamiento, brindando un sonido más potente e intenso.',
    },
    {
      id: 2,
      product: '',
      title: 'Conectividad',
      content: 'Los auriculares inalámbricos con Bluetooth 5.3 o superior garantizan una conectividad estable, especialmente en espacios de gimnasios abarrotados.',
    },
    {
      id: 3,
      product: '',
      title: 'Compatibilidad de dispositivos',
      content: 'Asegúrese de que los auriculares sean compatibles con varios dispositivos (teléfonos inteligentes, relojes inteligentes, etc.), lo que facilita el cambio de dispositivos durante un entrenamiento.',
    },
  ]
}

// Work
let Work_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 Work type1',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type2',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type3',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 2,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 3,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    },
    {
      id: 4,
      product: '',
      title: 'Subheading 1 type4',
      content: 'Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description Add a short description ',
    }
  ]
}

// TOZO Excellent Sound

// Superior Sound Quality
let superior_sound_quality_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enfoque mejorado',
      content: 'Bloquee el ruido de fondo que distrae, ya sea que esté trabajando, estudiando o viajando.',
    },
    {
      id: 2,
      product: '',
      title: 'Mejora de la calidad de audio',
      content: 'Experimente un sonido claro como el cristal sin interferencias de su entorno.',
    },
    {
      id: 3,
      product: '',
      title: 'Compacto y conveniente',
      content: 'El diseño ligero y portátil los hace perfectos para estilos de vida en movimiento.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Trabajo y estudio',
      content: 'Cree un espacio tranquilo para concentrarse en oficinas ruidosas o espacios públicos.',
    },
    {
      id: 2,
      product: '',
      title: 'Viajes',
      content: 'Reduzca el ruido del motor en aviones o trenes para un viaje más cómodo.',
    },
    {
      id: 3,
      product: '',
      title: 'Ejercicio y aire libre',
      content: 'Disfrute de música o podcasts sin distracciones durante los entrenamientos o actividades al aire libre.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Rendimiento de cancelación de ruido',
      content: 'Los auriculares ofrecen una cancelación de ruido superior para frecuencias bajas, mientras que los auriculares son ideales para el uso portátil y diario.',
    },
    {
      id: 2,
      product: '',
      title: 'Comodidad y ajuste',
      content: 'Los auriculares son ligeros y más cómodos para usar durante períodos prolongados, mientras que los auriculares pueden proporcionar un ajuste más ceñido para sesiones de escucha más largas.',
    },
    {
      id: 3,
      product: '',
      title: 'Portabilidad',
      content: 'Los auriculares son más compactos y fáciles de transportar, pero los auriculares suelen ofrecer una experiencia de audio más inmersiva.',
    },
  ],

  answer_type4: [

  ]
}

// Noise Canceling
let noise_canceling_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enfoque mejorado',
      content: 'Bloquee el ruido de fondo que distrae, ya sea que esté trabajando, estudiando o viajando.',
    },
    {
      id: 2,
      product: '',
      title: 'Mejora de la calidad de audio',
      content: 'Experimente un sonido claro como el cristal sin interferencias de su entorno.',
    },
    {
      id: 3,
      product: '',
      title: 'Compacto y conveniente',
      content: 'El diseño ligero y portátil los hace perfectos para estilos de vida en movimiento.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Trabajo y estudio',
      content: 'Cree un espacio tranquilo para concentrarse en oficinas ruidosas o espacios públicos.',
    },
    {
      id: 2,
      product: '',
      title: 'Viajes',
      content: 'Reduzca el ruido del motor en aviones o trenes para un viaje más cómodo.',
    },
    {
      id: 3,
      product: '',
      title: 'Ejercicio y aire libre',
      content: 'Disfrute de música o podcasts sin distracciones durante los entrenamientos o actividades al aire libre.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Rendimiento de cancelación de ruido',
      content: 'Los auriculares ofrecen una cancelación de ruido superior para frecuencias bajas, mientras que los auriculares son ideales para el uso portátil y diario.',
    },
    {
      id: 2,
      product: '',
      title: 'Comodidad y ajuste',
      content: 'Los auriculares son ligeros y más cómodos para usar durante períodos prolongados, mientras que los auriculares pueden proporcionar un ajuste más ceñido para sesiones de escucha más largas.',
    },
    {
      id: 3,
      product: '',
      title: 'Portabilidad',
      content: 'Los auriculares son más compactos y fáciles de transportar, pero los auriculares suelen ofrecer una experiencia de audio más inmersiva.',
    },
  ],

  answer_type4: [

  ]
}

// Long-lasting Battery
let long_lasting_battery_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enfoque mejorado',
      content: 'Bloquee el ruido de fondo que distrae, ya sea que esté trabajando, estudiando o viajando.',
    },
    {
      id: 2,
      product: '',
      title: 'Mejora de la calidad de audio',
      content: 'Experimente un sonido claro como el cristal sin interferencias de su entorno.',
    },
    {
      id: 3,
      product: '',
      title: 'Compacto y conveniente',
      content: 'El diseño ligero y portátil los hace perfectos para estilos de vida en movimiento.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Trabajo y estudio',
      content: 'Cree un espacio tranquilo para concentrarse en oficinas ruidosas o espacios públicos.',
    },
    {
      id: 2,
      product: '',
      title: 'Viajes',
      content: 'Reduzca el ruido del motor en aviones o trenes para un viaje más cómodo.',
    },
    {
      id: 3,
      product: '',
      title: 'Ejercicio y aire libre',
      content: 'Disfrute de música o podcasts sin distracciones durante los entrenamientos o actividades al aire libre.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Rendimiento de cancelación de ruido',
      content: 'Los auriculares ofrecen una cancelación de ruido superior para frecuencias bajas, mientras que los auriculares son ideales para el uso portátil y diario.',
    },
    {
      id: 2,
      product: '',
      title: 'Comodidad y ajuste',
      content: 'Los auriculares son ligeros y más cómodos para usar durante períodos prolongados, mientras que los auriculares pueden proporcionar un ajuste más ceñido para sesiones de escucha más largas.',
    },
    {
      id: 3,
      product: '',
      title: 'Portabilidad',
      content: 'Los auriculares son más compactos y fáciles de transportar, pero los auriculares suelen ofrecer una experiencia de audio más inmersiva.',
    },
  ],

  answer_type4: [

  ]
}

// Comfortable Fit
let comfortable_fit_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Enfoque mejorado',
      content: 'Bloquee el ruido de fondo que distrae, ya sea que esté trabajando, estudiando o viajando.',
    },
    {
      id: 2,
      product: '',
      title: 'Mejora de la calidad de audio',
      content: 'Experimente un sonido claro como el cristal sin interferencias de su entorno.',
    },
    {
      id: 3,
      product: '',
      title: 'Compacto y conveniente',
      content: 'El diseño ligero y portátil los hace perfectos para estilos de vida en movimiento.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Trabajo y estudio',
      content: 'Cree un espacio tranquilo para concentrarse en oficinas ruidosas o espacios públicos.',
    },
    {
      id: 2,
      product: '',
      title: 'Viajes',
      content: 'Reduzca el ruido del motor en aviones o trenes para un viaje más cómodo.',
    },
    {
      id: 3,
      product: '',
      title: 'Ejercicio y aire libre',
      content: 'Disfrute de música o podcasts sin distracciones durante los entrenamientos o actividades al aire libre.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Rendimiento de cancelación de ruido',
      content: 'Los auriculares ofrecen una cancelación de ruido superior para frecuencias bajas, mientras que los auriculares son ideales para el uso portátil y diario.',
    },
    {
      id: 2,
      product: '',
      title: 'Comodidad y ajuste',
      content: 'Los auriculares son ligeros y más cómodos para usar durante períodos prolongados, mientras que los auriculares pueden proporcionar un ajuste más ceñido para sesiones de escucha más largas.',
    },
    {
      id: 3,
      product: '',
      title: 'Portabilidad',
      content: 'Los auriculares son más compactos y fáciles de transportar, pero los auriculares suelen ofrecer una experiencia de audio más inmersiva.',
    },
  ],

  answer_type4: [

  ]
}

// Work Headphones
let Work_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Cancelación Activa de Ruido (ANC)',
      content: 'Opta por auriculares con ANC efectivo para minimizar el ruido ambiental de la oficina, como conversaciones y sonidos de equipos de oficina, permitiendo una concentración sin interrupciones.',
    },
    {
      id: 2,
      product: '',
      title: 'Modo de Transparencia',
      content: 'Elige modelos con una función de transparencia para mantenerte al tanto de tu entorno cuando sea necesario, facilitando un equilibrio entre el aislamiento y la conciencia situacional.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diseño Ergonómico',
      content: 'Selecciona auriculares con diademas ajustables y almohadillas acolchadas para garantizar un ajuste cómodo durante largos periodos de uso.',
    },
    {
      id: 2,
      product: '',
      title: 'Construcción Ligera',
      content: 'Los auriculares ligeros reducen la presión sobre la cabeza y las orejas, mejorando la comodidad durante largas sesiones de trabajo.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Audio Claro',
      content: "El sonido de alta fidelidad mejora la claridad en reuniones virtuales y contenido multimedia, garantizando una comunicación efectiva.",
    },
    {
      id: 2,
      product: '',
      title: 'Calidad del Micrófono',
      content: 'Los micrófonos integrados con funciones de cancelación de ruido garantizan que tu voz se escuche claramente durante las llamadas, minimizando malentendidos.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Emparejamiento con Múltiples Dispositivos',
      content: 'Los auriculares que permiten conexiones simultáneas a varios dispositivos, como computadoras y teléfonos inteligentes, ofrecen flexibilidad para gestionar diferentes herramientas de trabajo.',
    },
    {
      id: 2,
      product: '',
      title: 'Batería de Larga Duración',
      content: 'El rendimiento prolongado de la batería, idealmente más de 8 horas, permite jornadas completas de trabajo sin necesidad de recargas frecuentes, asegurando un uso ininterrumpido.',
    },
  ]
}

// Travel Headphones
let Travel_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ajuste y Comodidad',
      content: 'Opta por diseños ergonómicos que ofrezcan un ajuste seguro, como auriculares supraaurales con diademas ajustables o audífonos intraurales con almohadillas personalizables. Un buen ajuste garantiza comodidad durante largos periodos de uso, lo cual es crucial en vuelos largos o viajes prolongados.',
    },
    {
      id: 2,
      product: '',
      title: 'Estabilidad del Ajuste',
      content: 'Elige auriculares que se mantengan firmemente en su lugar, especialmente durante el movimiento. Características como ganchos para las orejas o puntas aladas pueden mejorar la estabilidad y evitar ajustes constantes.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Resistencia al Sudor y al Agua',
      content: 'Selecciona auriculares con al menos una clasificación IPX4 para garantizar que puedan soportar el sudor y la humedad, haciéndolos adecuados para diversas condiciones de viaje.',
    },
    {
      id: 2,
      product: '',
      title: 'Durabilidad',
      content: 'Busca auriculares con una construcción resistente que soporte caídas y arañazos, garantizando un rendimiento duradero, especialmente en entornos al aire libre o de alto impacto.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Duración de la Batería',
      content: "Opta por modelos con batería de larga duración, idealmente entre 20 y 30 horas, para que duren durante vuelos largos o varios días de viaje sin necesidad de recargas frecuentes.",
    },
    {
      id: 2,
      product: '',
      title: 'Eficiencia de Carga',
      content: 'Algunos auriculares ofrecen carga rápida, proporcionando varias horas de uso con solo unos minutos de carga, una característica beneficiosa para los viajeros frecuentes.',
    },
    {
      id: 3,
      product: '',
      title: 'Funciones de Control',
      content: 'Los controles fáciles de usar en el dispositivo o la integración con asistentes de voz permiten ajustar el volumen de la música o responder llamadas sin interrumpir tus actividades.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Calidad del Sonido',
      content: 'Un sonido claro con bajos potentes puede mejorar tu experiencia de viaje, proporcionando un audio envolvente para música, podcasts o películas.',
    },
    {
      id: 2,
      product: '',
      title: 'Conectividad',
      content: 'Los auriculares inalámbricos con Bluetooth 5.3 o superior garantizan una conexión estable, especialmente en áreas concurridas como aeropuertos o transporte público.',
    },
    {
      id: 3,
      product: '',
      title: 'Compatibilidad con Dispositivos',
      content: 'Asegúrate de que los auriculares sean compatibles con varios dispositivos (teléfonos inteligentes, tabletas, computadoras portátiles), facilitando la conexión entre ellos durante tus viajes.',
    },
  ]
}


// Over-Ear Headphones
let Over_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Tecnología del controlador',
      content: 'Los controladores de alta calidad son fundamentales para un sonido claro y equilibrado.',
    },
    {
      id: 2,
      product: '',
      title: 'Respuesta de frecuencia',
      content: 'Un rango de frecuencia amplio permite una reproducción de audio más detallada, capturando tanto los graves profundos como los agudos altos.',
    },
    {
      id: 3,
      product: '',
      title: 'Distorsión armónica total (THD)',
      content: 'Valores más bajos de THD indican menos distorsión a altos volúmenes, lo que garantiza un sonido claro y preciso.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Material de las almohadillas',
      content: 'Materiales suaves y transpirables como espuma viscoelástica cubierta con cuero o terciopelo mejoran la comodidad y reducen la acumulación de calor durante el uso prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Diadema ajustable',
      content: 'Una diadema fácilmente ajustable garantiza un ajuste seguro para diferentes tamaños de cabeza, evitando molestias o puntos de presión.',
    },
    {
      id: 3,
      product: '',
      title: 'Peso',
      content: 'Los diseños ligeros minimizan la tensión en la cabeza y el cuello, lo que los hace adecuados para sesiones de escucha prolongadas.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Cancelación activa de ruido (ANC)',
      content: 'Esta tecnología utiliza micrófonos para detectar y contrarrestar el ruido externo, proporcionando un entorno de escucha más inmersivo y reduciendo eficazmente los sonidos ambientales durante los viajes o en entornos ruidosos.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento pasivo de ruido',
      content: 'Las copas bien diseñadas que se sellan alrededor de las orejas pueden bloquear naturalmente los sonidos ambientales sin intervención electrónica.',
    },
    {
      id: 3,
      product: '',
      title: 'Modo transparencia',
      content: 'Algunos auriculares ofrecen un modo que permite la entrada de sonidos externos, lo que permite mantener la conciencia del entorno cuando sea necesario.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Duración de la batería',
      content: 'Para los modelos inalámbricos, considere auriculares que ofrezcan una batería de larga duración para reducir la necesidad de cargar con frecuencia.',
    },
    {
      id: 2,
      product: '',
      title: 'Capacidad de carga rápida',
      content: 'Funciones como la carga rápida pueden proporcionar varias horas de reproducción con solo un corto tiempo de carga.',
    },
    {
      id: 3,
      product: '',
      title: 'Versión de Bluetooth y códecs',
      content: 'Asegúrese de que los auriculares sean compatibles con las versiones más recientes de Bluetooth y códecs de audio de alta calidad (por ejemplo, aptX, AAC) para conexiones estables y mejor calidad de sonido.',
    },
  ]  
}

// Waterproof Earbuds
let Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Sistema de clasificación IPX',
      content: 'La clasificación de protección de ingreso (IP) indica el nivel de protección contra sólidos y líquidos. Por ejemplo, una clasificación IPX7 significa que el dispositivo puede soportar la inmersión en agua hasta 1 metro durante 30 minutos, mientras que IPX4 ofrece protección contra salpicaduras desde cualquier dirección.',
    },
    {
      id: 2,
      product: '',
      title: 'Protección contra el polvo',
      content: 'El primer dígito en una clasificación IP indica la protección contra sólidos como el polvo. Una clasificación IP6X significa protección completamente hermética al polvo, lo cual es crucial para mantener la funcionalidad en entornos polvorientos.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Tecnología del controlador',
      content: 'Los controladores de alta calidad son esenciales para un sonido claro y equilibrado.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento y cancelación de ruido',
      content: 'Un aislamiento pasivo de ruido efectivo, logrado a través de puntas bien ajustadas, puede mejorar la calidad del sonido al minimizar las distracciones externas.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Diseño de las puntas',
      content: 'Los auriculares con múltiples tamaños de puntas aseguran un ajuste cómodo y seguro, crucial para el uso prolongado y mantener la calidad del sonido.',
    },
    {
      id: 2,
      product: '',
      title: 'Funciones de estabilidad',
      content: 'Para usuarios activos, características como ganchos o aletas para las orejas brindan estabilidad adicional durante los entrenamientos o actividades con mucho movimiento.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Duración de la batería',
      content: 'Considere auriculares con batería de larga duración para reducir la frecuencia de carga.',
    },
    {
      id: 2,
      product: '',
      title: 'Opciones de conectividad',
      content: 'Asegúrese de que los auriculares sean compatibles con conexiones Bluetooth estables y con sus dispositivos. Características como el emparejamiento multipunto pueden ser ventajosas para cambiar sin problemas entre dispositivos.',
    },
  ]  
}

// Open Ear Headphones
let Open_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Rango de frecuencia amplio',
      content: 'Los auriculares de oído abierto deben ofrecer un amplio rango de frecuencias para un sonido rico y equilibrado. Cuanto más amplio sea el rango, mejor será el rendimiento de audio en todas las frecuencias, desde graves profundos hasta agudos nítidos.',
    },
    {
      id: 2,
      product: '',
      title: 'Controladores de audio',
      content: 'Busque auriculares con controladores de alta calidad. Los controladores más grandes o duales pueden proporcionar un sonido más claro e inmersivo.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño abierto por detrás',
      content: 'El diseño abierto por detrás garantiza una escena sonora natural y una experiencia de escucha más aireada. Permite oír una mezcla más realista de sonidos, aunque puede no bloquear tanto el ruido externo como los auriculares circumaurales. Es ideal para escuchar mientras se permanece consciente del entorno.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Construcción ligera',
      content: 'Los auriculares de oído abierto suelen ser más ligeros que los modelos circumaurales tradicionales. Su diseño liviano reduce la fatiga en la cabeza y el cuello, lo que los hace ideales para sesiones de escucha prolongadas.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajuste seguro para el movimiento',
      content: 'Asegúrese de que los auriculares tengan un ajuste seguro, especialmente si planea usarlos para hacer ejercicio o actividades al aire libre. Las diademas ajustables y los ganchos o aletas suaves ayudan a mantener los auriculares en su lugar durante el movimiento físico.',
    },
    {
      id: 3,
      product: '',
      title: 'Materiales transpirables',
      content: 'El acolchado cómodo o los materiales de malla alrededor de las orejas y la diadema permiten la transpirabilidad, evitando la acumulación de calor durante períodos largos de uso. Esto es especialmente importante si planea usarlos durante horas.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth y emparejamiento multipunto',
      content: 'Asegúrese de que los auriculares cuenten con soporte Bluetooth para una mayor comodidad inalámbrica. Algunos modelos ofrecen emparejamiento multipunto, lo que permite conectarse a varios dispositivos al mismo tiempo (por ejemplo, teléfono y computadora), aumentando su utilidad.',
    },
    {
      id: 2,
      product: '',
      title: 'Controles de audio y asistente por voz',
      content: 'Busque auriculares con controles fáciles de usar, como ajuste de volumen, reproducción/pausa y cambio de pista. Los asistentes de voz integrados también pueden ser una buena característica para el uso manos libres.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al agua',
      content: 'Para uso en exteriores, asegúrese de que los auriculares tengan cierto nivel de resistencia al agua, como una clasificación IPX4 o superior. Esto garantiza que puedan soportar el sudor, la lluvia o salpicaduras durante actividades como correr o andar en bicicleta.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Busque auriculares de oído abierto con larga duración de batería para una escucha continua. Modelos como el NC9 ofrecen hasta 8 horas de batería, lo cual es ideal para entrenamientos prolongados o desplazamientos.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'Considere auriculares con capacidades de carga rápida. Muchos modelos ofrecen una hora o más de uso con solo una breve carga, lo que es útil si tiene poco tiempo.',
    },
    {
      id: 3,
      product: '',
      title: 'Durabilidad y calidad de construcción',
      content: 'La calidad de construcción de los auriculares de oído abierto es importante, especialmente si los usa en exteriores. Asegúrese de que estén fabricados con materiales duraderos que puedan soportar la actividad física y caídas ocasionales. Una construcción de alta calidad garantiza longevidad y buen rendimiento.',
    },
  ]  
}

// Ture Wireless Earbuds
let Ture_Wireless_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Calidad del controlador',
      content: 'Los controladores de alta calidad mejoran la claridad del sonido y los graves. Los controladores más grandes suelen proporcionar una mejor respuesta de bajos, mientras que las tecnologías avanzadas mejoran el rendimiento general del audio.',
    },
    {
      id: 2,
      product: '',
      title: 'Cancelación de ruido',
      content: 'La cancelación activa de ruido (ANC) reduce el ruido de fondo mediante el uso de micrófonos y ondas sonoras, permitiendo una experiencia auditiva inmersiva en entornos ruidosos.',
    },
    {
      id: 3,
      product: '',
      title: 'Rango de frecuencia',
      content: 'Un rango de frecuencia más amplio permite a los auriculares reproducir un sonido más rico y dinámico, capturando tanto los graves profundos como los agudos altos para una experiencia de audio equilibrada en varios géneros musicales.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Opciones de puntas para los oídos',
      content: 'Elija auriculares con múltiples tamaños de puntas de silicona o espuma para un ajuste seguro y cómodo, lo que mejora la calidad del sonido y el aislamiento del ruido durante sesiones prolongadas.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Seleccione auriculares con formas ergonómicas que se adapten naturalmente al oído, garantizando comodidad durante un uso prolongado.',
    },
    {
      id: 3,
      product: '',
      title: 'Ajuste seguro para uso activo',
      content: 'Para actividades físicas, opte por auriculares con características de sujeción como ganchos o aletas que eviten que se caigan durante movimientos intensos.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Elija auriculares que ofrezcan una batería de larga duración, como modelos que proporcionan hasta 15 horas con una sola carga, asegurando una escucha ininterrumpida durante viajes o usos prolongados.',
    },
    {
      id: 2,
      product: '',
      title: 'Estuche de carga',
      content: 'Seleccione auriculares con un estuche de carga de alta capacidad, que permita múltiples recargas en movimiento. Los estuches con carga rápida pueden proporcionar horas de reproducción con solo una breve carga.',
    },
    {
      id: 3,
      product: '',
      title: 'Carga inalámbrica',
      content: 'Opte por auriculares que admitan carga inalámbrica para mayor comodidad, permitiendo recargar el estuche con bases de carga compatibles y reduciendo el desorden de cables.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Alcance y estabilidad del Bluetooth',
      content: 'Opte por auriculares con Bluetooth 5.0 o superior para un emparejamiento más rápido, mayor alcance y conexiones estables, lo que garantiza un rendimiento fluido durante llamadas y transmisión de audio.',
    },
    {
      id: 2,
      product: '',
      title: 'Emparejamiento con múltiples dispositivos',
      content: 'Esta función permite cambiar sin problemas entre dispositivos como teléfonos y laptops sin necesidad de volver a emparejar, lo que mejora la comodidad.',
    },
    {
      id: 3,
      product: '',
      title: 'Integración con asistentes de voz',
      content: 'Los auriculares con soporte integrado para Siri, Google Assistant o Alexa permiten un control manos libres para tareas como ajustar el volumen, cambiar de pista o realizar llamadas.',
    },
  ]  
}

// Hi Res Audio Headphones
let Hi_Res_Audio_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Compatibilidad con audio de alta resolución',
      content: 'Los auriculares deben admitir una profundidad de 24 bits y frecuencias de muestreo de al menos 96kHz para calificar como Audio Hi-Res, lo que garantiza que capturen detalles sutiles que los auriculares estándar podrían pasar por alto.',
    },
    {
      id: 2,
      product: '',
      title: 'Tecnología de controladores',
      content: 'Los auriculares Hi-Res suelen utilizar controladores avanzados como los de tipo planar magnético o electrostático, que ofrecen mayor claridad de sonido y mejor respuesta de graves.',
    },
    {
      id: 3,
      product: '',
      title: 'Rango de frecuencia',
      content: 'Estos auriculares suelen tener un rango de frecuencia más amplio, generalmente de 20Hz a 40kHz, lo que permite reproducir graves profundos y agudos brillantes para una experiencia auditiva completa.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diseño de la diadema y las copas',
      content: 'Las diademas ajustables y las copas acolchadas, a menudo con espuma viscoelástica, garantizan un ajuste cómodo y seguro durante sesiones de escucha prolongadas.',
    },
    {
      id: 2,
      product: '',
      title: 'Peso y materiales',
      content: 'Materiales duraderos pero ligeros como el aluminio o plásticos de alta calidad evitan la fatiga durante el uso prolongado.',
    },
    {
      id: 3,
      product: '',
      title: 'Acolchado y sellado de los auriculares',
      content: 'Las almohadillas de espuma viscoelástica o acolchadas proporcionan un buen sellado, minimizando el ruido externo y mejorando la calidad de sonido para una experiencia auditiva más rica.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Auriculares con cable vs inalámbricos',
      content: 'Los auriculares con cable ofrecen mayor fidelidad de audio, mientras que los inalámbricos brindan conveniencia, aunque pueden comprometer la calidad debido a la compresión por Bluetooth.',
    },
    {
      id: 2,
      product: '',
      title: 'Cancelación o aislamiento de ruido',
      content: 'La cancelación activa de ruido (ANC) reduce los sonidos externos electrónicamente, mejorando la inmersión. El aislamiento pasivo se basa en el diseño y materiales para bloquear el ruido.',
    },
    {
      id: 3,
      product: '',
      title: 'Bluetooth y compatibilidad con códecs',
      content: 'Para audio Hi-Res inalámbrico, asegúrese de que los auriculares sean compatibles con códecs de alta definición como LDAC o aptX HD para una mejor calidad de sonido.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Calidad de construcción',
      content: 'Opte por auriculares fabricados con materiales duraderos como aluminio o titanio para mayor longevidad. Los diseños plegables mejoran la portabilidad sin comprometer la resistencia estructural.',
    },
    {
      id: 2,
      product: '',
      title: 'Duración de la batería (para modelos inalámbricos)',
      content: 'Elija auriculares inalámbricos que ofrezcan entre 20 y 30 horas de reproducción por carga. Las funciones de carga rápida permiten un uso prolongado con tiempos de carga reducidos.',
    },
    {
      id: 3,
      product: '',
      title: 'Clasificación IP de resistencia al agua',
      content: 'Para uso en exteriores o ejercicio, elija auriculares con una alta clasificación IP (por ejemplo, IPX5 o IPX7) que garanticen resistencia al sudor y la lluvia.',
    },
  ]  
}

// Comfortable Headphones
let Comfortable_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Almohadillas de espuma viscoelástica o acolchadas',
      content: 'Busca auriculares con almohadillas de espuma viscoelástica o acolchadas que se adapten a la forma de tus orejas, reduciendo la presión y ofreciendo comodidad durante sesiones largas de escucha.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño circumaural vs supraaural',
      content: 'Los auriculares circumaurales cubren completamente las orejas, brindando mayor comodidad y aislamiento. Los modelos supraaurales son más ligeros, pero pueden causar molestias en usos prolongados. Prueba el ajuste antes de comprar.',
    },
    {
      id: 3,
      product: '',
      title: 'Materiales transpirables',
      content: 'Elige auriculares con copas hechas de malla o tela transpirable para evitar la acumulación de calor y sudor, garantizando comodidad durante sesiones largas o entrenamientos.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diadema ajustable',
      content: 'Elige auriculares con una diadema ajustable hecha de materiales suaves como espuma viscoelástica o tela acolchada para un ajuste personalizado y distribución uniforme de presión, asegurando comodidad en uso prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajuste seguro',
      content: 'Una diadema segura y ajustable garantiza un ajuste firme. Evita auriculares que se deslicen o que sean demasiado apretados. El objetivo es un ajuste cómodo y firme durante el movimiento o el ejercicio.',
    },
    {
      id: 3,
      product: '',
      title: 'Distribución del peso',
      content: 'Busca auriculares con buena distribución del peso para evitar acumulación de presión. Materiales ligeros como plástico o aluminio ofrecen durabilidad sin agregar volumen, asegurando un ajuste cómodo.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Cancelación activa de ruido (ANC)',
      content: 'La ANC bloquea el ruido externo, mejorando la comodidad y concentración, especialmente en entornos ruidosos como cafeterías u oficinas. Reduce la necesidad de subir el volumen, haciendo la escucha más relajante.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento pasivo de ruido',
      content: 'Los auriculares circumaurales proporcionan aislamiento pasivo cubriendo tus orejas y bloqueando el ruido ambiente sin depender de ANC. Ideales para quienes buscan enfoque sin necesidad de batería.',
    },
    {
      id: 3,
      product: '',
      title: 'Prevención de fuga de sonido',
      content: 'Los auriculares con diseño ajustado evitan la fuga de sonido, asegurando una escucha privada sin molestar a otros. Busca modelos bien sellados que equilibren comodidad y aislamiento.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Construcción resistente pero ligera',
      content: 'Elige auriculares fabricados con plásticos de alta calidad, aluminio o acero para garantizar durabilidad sin peso excesivo. Un marco bien construido ofrece comodidad duradera sin ser pesado.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño plegable o colapsable',
      content: 'Los auriculares plegables o colapsables son fáciles de guardar y transportar, reduciendo el riesgo de daños durante viajes. Perfectos para usuarios en movimiento o viajeros frecuentes.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al sudor y al agua',
      content: 'Para entrenamientos o actividades al aire libre, elige auriculares resistentes al sudor y al agua con clasificación IPX, asegurando durabilidad y comodidad en distintas condiciones. Ideales para deportistas o usuarios activos.',
    },
  ]  
}

// Gaming Headphones
let Gaming_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Audio de alta resolución',
      content: 'Para un sonido claro y detallado que mejore tu experiencia de juego, busca auriculares con audio de alta resolución. Proporcionan claridad para escuchar detalles importantes dentro del juego.',
    },
    {
      id: 2,
      product: '',
      title: 'Capacidad de sonido envolvente',
      content: 'Los auriculares con sonido envolvente (como Dolby Atmos) simulan un sonido 3D, lo que te ayuda a localizar enemigos y añade profundidad al entorno de juego.',
    },
    {
      id: 3,
      product: '',
      title: 'Respuesta de bajos profundos',
      content: 'Unos graves potentes son esenciales para una experiencia más dinámica, dando más impacto a explosiones, disparos y otros momentos de acción del juego.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Almohadillas acolchadas',
      content: 'Busca auriculares con almohadillas suaves y viscoelásticas para reducir la presión y aumentar la comodidad durante largas sesiones de juego. Esto previene la fatiga en las orejas.',
    },
    {
      id: 2,
      product: '',
      title: 'Diadema ajustable',
      content: 'Una diadema ajustable y acolchada ofrece un ajuste seguro pero cómodo, permitiéndote jugar durante horas sin molestias.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño ligero',
      content: 'Elige auriculares ligeros que no resulten pesados tras varias horas de juego, garantizando comodidad constante durante toda la sesión.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Micrófono con cancelación de ruido',
      content: 'Un micrófono con cancelación de ruido garantiza una comunicación clara al filtrar sonidos de fondo, ideal para juegos en equipo o en línea.',
    },
    {
      id: 2,
      product: '',
      title: 'Micrófono desmontable',
      content: 'Un micrófono desmontable ofrece flexibilidad, ya que puedes retirarlo cuando no lo necesites, reduciendo distracciones en juegos para un solo jugador.',
    },
    {
      id: 3,
      product: '',
      title: 'Micrófono con posición ajustable',
      content: 'Auriculares con micrófono flexible o ajustable permiten colocarlo cerca de la boca para mayor claridad en la comunicación.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Construcción resistente',
      content: 'Los auriculares para gaming deben estar hechos de materiales duraderos como aluminio o plásticos de alta calidad, para soportar un uso intensivo sin romperse.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño plegable y flexible',
      content: 'Los diseños plegables facilitan el almacenamiento, y las bisagras flexibles permiten ajustar los auriculares sin dañar la estructura.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al sudor y al agua',
      content: 'Auriculares con resistencia al sudor o al agua ofrecen mayor durabilidad, especialmente útil durante sesiones de juego intensas o uso prolongado.',
    },
  ]  
}

// Long Battery Life Earbuds
let Long_Battery_Life_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Mayor capacidad en mAh',
      content: 'Busca auriculares con mayor capacidad de batería (mAh) para un tiempo de reproducción más prolongado, asegurando una escucha sin interrupciones durante tus desplazamientos o entrenamientos.',
    },
    {
      id: 2,
      product: '',
      title: 'Función de carga rápida',
      content: 'Los auriculares con carga rápida son ideales para recargas rápidas cuando tienes prisa, ofreciendo horas de reproducción tras unos minutos de carga.',
    },
    {
      id: 3,
      product: '',
      title: 'Larga duración en espera',
      content: 'Asegúrate de que los auriculares tengan una larga duración en modo espera, para conservar batería cuando no se usan y así alargar su vida útil entre cargas.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Estuche de carga con gran batería',
      content: 'Un estuche de carga con mayor capacidad amplía el tiempo total de uso, permitiéndote cargar los auriculares varias veces mientras viajas.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño portátil',
      content: 'Elige un estuche de carga compacto y fácil de transportar que te permita recargar tus auriculares sobre la marcha sin ocupar mucho espacio.',
    },
    {
      id: 3,
      product: '',
      title: 'Compatibilidad con carga inalámbrica',
      content: 'Algunos estuches permiten carga inalámbrica, lo que facilita la recarga sin necesidad de cables, ideal especialmente durante los viajes.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Bajo consumo de energía',
      content: 'Auriculares con bajo consumo energético ofrecen mayor duración de batería sin sacrificar rendimiento, dándote más horas de uso continuo.',
    },
    {
      id: 2,
      product: '',
      title: 'Gestión de energía adaptativa',
      content: 'Auriculares inteligentes ajustan su consumo según la actividad (por ejemplo, escuchando música o en modo espera), para maximizar la duración de la batería a lo largo del día.',
    },
    {
      id: 3,
      product: '',
      title: 'Eficiencia según versión Bluetooth',
      content: 'Versiones más nuevas de Bluetooth (como 5.0) ofrecen una mejor gestión energética, prolongando la duración de la batería sin perder calidad de conexión.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Impacto de la cancelación activa de ruido (ANC)',
      content: 'La ANC puede reducir la duración de la batería más rápidamente, por eso es recomendable elegir auriculares con un sistema ANC eficiente que equilibre calidad de sonido y autonomía.',
    },
    {
      id: 2,
      product: '',
      title: 'Controles táctiles y asistente de voz',
      content: 'Funciones como controles táctiles o asistentes de voz consumen más energía, así que asegúrate de que los auriculares estén optimizados para equilibrar rendimiento y duración de batería.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al agua',
      content: 'Los auriculares con alta clasificación de impermeabilidad (IPX7 o superior) suelen ofrecer mejor eficiencia energética al proteger la batería contra daños por humedad durante su uso.',
    },
  ]  
}

// Translate Earbuds
let Translate_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Algoritmos avanzados de traducción',
      content: 'Busca auriculares con algoritmos de traducción impulsados por IA para obtener traducciones de voz precisas en tiempo real, reduciendo errores durante la comunicación.',
    },
    {
      id: 2,
      product: '',
      title: 'Soporte multilingüe',
      content: 'Asegúrate de que los auriculares sean compatibles con una amplia gama de idiomas para facilitar la comunicación entre diferentes culturas.',
    },
    {
      id: 3,
      product: '',
      title: 'Baja latencia',
      content: 'Opta por auriculares con traducción de baja latencia para minimizar retrasos y lograr conversaciones más naturales.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Conectividad Bluetooth',
      content: 'Elige auriculares con Bluetooth 5.0 o superior para una conexión estable con smartphones o apps de traducción, sin interferencias.',
    },
    {
      id: 2,
      product: '',
      title: 'Compatibilidad con aplicaciones',
      content: 'Verifica que los auriculares funcionen con las aplicaciones de traducción más populares para una mayor funcionalidad y flexibilidad de idiomas.',
    },
    {
      id: 3,
      product: '',
      title: 'Emparejamiento con múltiples dispositivos',
      content: 'Selecciona auriculares que permitan la conexión simultánea con varios dispositivos, facilitando el cambio entre distintas plataformas de comunicación.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Los auriculares con un ajuste ergonómico y cómodo ayudan a reducir la fatiga auditiva, siendo ideales para largas sesiones de traducción.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajuste seguro',
      content: 'Busca auriculares que se mantengan firmemente en su lugar, especialmente al usarlos en viajes o conversaciones activas.',
    },
    {
      id: 3,
      product: '',
      title: 'Varios tamaños de almohadillas',
      content: 'Elige auriculares que incluyan diferentes tamaños de almohadillas para garantizar un ajuste perfecto y una calidad de sonido óptima durante la traducción.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Una batería de larga duración es esencial para sesiones de traducción prolongadas, así que elige auriculares que ofrezcan varias horas de uso por carga.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'Los auriculares con carga rápida son ideales para situaciones urgentes, asegurando energía cuando más la necesitas.',
    },
    {
      id: 3,
      product: '',
      title: 'Estuche de carga portátil',
      content: 'Un estuche de carga portátil te permite recargar los auriculares mientras te desplazas, asegurando que siempre estén listos para usar durante los viajes.',
    },
  ]  
}

// Sleep Headphones
let Sleep_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Almohadillas suaves y acolchadas',
      content: 'Elige auriculares para dormir con almohadillas de espuma viscoelástica o tela suave que minimicen la presión y garanticen comodidad durante toda la noche.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño con cinta o diadema',
      content: 'Los auriculares con diseño tipo diadema son ideales para mantener los audífonos en su lugar sin incomodar las orejas, especialmente para quienes duermen de lado.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño ligero',
      content: 'Opta por auriculares ligeros que no se sientan pesados o voluminosos, permitiéndote descansar sin distracciones durante la noche.',
    },
  ],
  
  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Función de cancelación de ruido',
      content: 'Los auriculares con cancelación de ruido ayudan a bloquear sonidos del entorno, permitiendo un sueño más tranquilo al reducir las interrupciones.',
    },
    {
      id: 2,
      product: '',
      title: 'Calidad de sonido relajante',
      content: 'Busca auriculares que ofrezcan sonido de alta calidad, ideales para música relajante o ruido blanco que te ayuden a conciliar el sueño más rápido.',
    },
    {
      id: 3,
      product: '',
      title: 'Volumen ajustable',
      content: 'El control de volumen ajustable te permite establecer el nivel de sonido perfecto, ni demasiado alto ni tan bajo como para perturbar tu sueño.',
    },
  ],
  
  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Los auriculares para dormir con batería de larga duración aseguran que puedas usarlos toda la noche sin tener que recargarlos.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'La función de carga rápida permite recargar tus auriculares en poco tiempo, asegurando que estén listos antes de ir a dormir.',
    },
    {
      id: 3,
      product: '',
      title: 'Modo de bajo consumo',
      content: 'Busca auriculares para dormir con funciones de ahorro de energía para prolongar la vida útil de la batería y reducir la necesidad de recargas frecuentes.',
    },
  ],
  
  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Construcción duradera',
      content: 'Los auriculares para dormir deben estar fabricados con materiales resistentes y flexibles para soportar el uso diario, especialmente si los usas cada noche.',
    },
    {
      id: 2,
      product: '',
      title: 'Tela lavable',
      content: 'Elige auriculares con fundas removibles y lavables para mantenerlos frescos y limpios, asegurando una buena higiene a lo largo del tiempo.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al sudor y la humedad',
      content: 'Los auriculares para dormir deben ser resistentes al sudor y la humedad, garantizando durabilidad incluso si los usas durante el ejercicio o mientras duermes.',
    },
  ]  
}

// Kids Headphones
let Kids_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Tecnología de Límite de Volumen',
      content: 'Busca auriculares con límites de volumen integrados (85-90dB), que protegen la audición de los niños al evitar niveles de audio peligrosamente altos.',
    },
    {
      id: 2,
      product: '',
      title: 'Cancelación de Ruido para Entornos Silenciosos',
      content: 'Los auriculares con cancelación de ruido reducen el ruido externo, lo que permite a los niños disfrutar del audio a volúmenes más bajos y seguros.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño Ligero y Cómodo',
      content: 'Elige auriculares ligeros para evitar tensión en los oídos de los niños y ofrecer comodidad durante sesiones de escucha prolongadas.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Construido para un Uso Robusto',
      content: 'Los auriculares diseñados para niños deben ser duraderos, con materiales resistentes que pueden soportar un manejo áspero, caídas o doblazos accidentales.',
    },
    {
      id: 2,
      product: '',
      title: 'Faja Ajustable',
      content: 'Las fajas ajustables aseguran un ajuste cómodo para los niños en crecimiento, adaptándose a diferentes tamaños de cabeza y mejorando la duración útil de los auriculares.',
    },
    {
      id: 3,
      product: '',
      title: 'Cables Sin Enredos o Diseño Inalámbrico',
      content: 'Elige cables inalámbricos o sin enredos para una mayor facilidad de uso y evitar la frustración con los cables enredados.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Almohadillas Suaves para los Oídos',
      content: 'Busca auriculares con almohadillas suaves y acolchadas para aumentar la comodidad y evitar dolor de oídos durante un uso prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajuste Ajustable',
      content: 'Las fajas ajustables y los auriculares permiten un ajuste personalizado, asegurando la comodidad a medida que los niños crecen y proporcionando un ajuste ajustado.',
    },
    {
      id: 3,
      product: '',
      title: 'Materiales Respirantes',
      content: 'Los auriculares hechos de materiales respirantes evitan el sobrecalentamiento, asegurando que los oídos de los niños se mantengan frescos y cómodos.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Colores y Estilos Divertidos',
      content: 'Elige auriculares con colores vibrantes y diseños divertidos para que sean más atractivos para los niños y animar su uso.',
    },
    {
      id: 2,
      product: '',
      title: 'Controles Simples',
      content: 'Los auriculares adecuados para niños deben tener botones fáciles de usar o controles táctiles, para que los niños puedan ajustar el volumen o saltar canciones de forma independiente.',
    },
    {
      id: 3,
      product: '',
      title: 'Plegable y Portátil',
      content: 'Los diseños plegables facilitan el almacenamiento, por lo que los niños pueden llevar sus auriculares con ellos sin ocupar demasiado espacio.',
    },
  ]
}

// IPX7 Waterproof Earbuds
let IPX7_Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ajuste Seguro',
      content: 'Ganchos para las orejas o diseños ergonómicos que evitan que se deslicen durante el movimiento.',
    },
    {
      id: 2,
      product: '',
      title: 'Resistencia al Sudor',
      content: 'Materiales diseñados para soportar la transpiración.',
    },
    {
      id: 3,
      product: '',
      title: 'Duración de la Batería',
      content: 'Reproducción prolongada para entrenamientos largos.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Cancelación de Ruido',
      content: 'Funciones activas o pasivas para reducir el ruido ambiental.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño Compacto',
      content: 'Fácil de transportar y cabe en el bolsillo.',
    },
    {
      id: 3,
      product: '',
      title: 'Carga Rápida',
      content: 'Capacidad de carga rápida para uso en movimiento.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Calidad de Sonido',
      content: 'Audio de alta fidelidad con bajos profundos y agudos claros.',
    },
    {
      id: 2,
      product: '',
      title: 'Compatibilidad con Códecs',
      content: 'Compatible con códecs avanzados como aptX o AAC.',
    },
    {
      id: 3,
      product: '',
      title: 'Tamaño del Controlador',
      content: 'Controladores más grandes para una experiencia sonora más rica.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Precio Asequible',
      content: 'Funciones de alta calidad a un precio competitivo.',
    },
    {
      id: 2,
      product: '',
      title: 'Durabilidad',
      content: 'Construcción duradera para garantizar valor a largo plazo.',
    },
    {
      id: 3,
      product: '',
      title: 'Garantía',
      content: 'Cobertura integral para mayor tranquilidad.',
    },
  ]
}

// IPX8 Waterproof Earbuds
let IPX8_Waterproof_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ajuste ergonómico',
      content: 'Diseño ergonómico para un ajuste seguro.',
    },
    {
      id: 2,
      product: '',
      title: 'Variedad de almohadillas',
      content: 'Incluye varios tamaños de almohadillas.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño ligero',
      content: 'Ligero para uso prolongado.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Tiempo de reproducción prolongado por carga.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'Capacidad de carga rápida.',
    },
    {
      id: 3,
      product: '',
      title: 'Estuche de carga',
      content: 'Estuche de carga para energía portátil.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Graves potentes',
      content: 'Controladores avanzados para graves profundos.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento de ruido',
      content: 'Aislamiento de ruido para un sonido claro.',
    },
    {
      id: 3,
      product: '',
      title: 'Conexión estable',
      content: 'Conectividad Bluetooth estable.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Controles táctiles',
      content: 'Controles táctiles para una operación sencilla.',
    },
    {
      id: 2,
      product: '',
      title: 'Compatibilidad con asistente de voz',
      content: 'Compatible con asistentes de voz.',
    },
    {
      id: 3,
      product: '',
      title: 'Micrófono integrado',
      content: 'Micrófono incorporado para llamadas.',
    },
  ]
}

// IPX6 Earbuds
let IPX6_Earbuds_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Audio de alta fidelidad',
      content: 'Busca auriculares que ofrezcan un sonido claro y equilibrado.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento de ruido',
      content: 'Asegúrate de que bloqueen eficazmente el ruido ambiental.',
    },
    {
      id: 3,
      product: '',
      title: 'Rendimiento de graves',
      content: 'Considera auriculares con graves mejorados para una experiencia más rica.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Elige auriculares que se ajusten de forma segura sin causar molestias.',
    },
    {
      id: 2,
      product: '',
      title: 'Variedad de tamaños de almohadillas',
      content: 'Las opciones permiten un ajuste personalizado.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño ligero',
      content: 'Reduce la fatiga auditiva durante el uso prolongado.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Carga de larga duración',
      content: 'Opta por auriculares que ofrezcan un tiempo de reproducción prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'Las funciones que permiten una recarga rápida son beneficiosas.',
    },
    {
      id: 3,
      product: '',
      title: 'Indicador de batería',
      content: 'Ayuda a monitorear fácilmente la energía restante.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Conexión Bluetooth estable',
      content: 'Garantiza una transmisión de audio sin interrupciones.',
    },
    {
      id: 2,
      product: '',
      title: 'Compatibilidad',
      content: 'Verifica la compatibilidad con tus dispositivos.',
    },
    {
      id: 3,
      product: '',
      title: 'Baja latencia',
      content: 'Importante para ver videos y jugar.',
    },
  ]
}

// Behind the Ear Headphones
Behind_the_Ear_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Diseño cómodo',
      content: 'Los audífonos detrás de la oreja están diseñados para ofrecer comodidad durante sesiones prolongadas, con ganchos suaves o diseños ergonómicos que no causan molestias.',
    },
    {
      id: 2,
      product: '',
      title: 'Estabilidad',
      content: 'El diseño evita que se deslicen, lo que los hace ideales para usuarios activos que necesitan audífonos que se mantengan en su lugar durante movimientos intensos.',
    },
    {
      id: 3,
      product: '',
      title: 'Ajuste ajustable',
      content: 'Busca audífonos con puntas o bucles ajustables para personalizar el ajuste a tu cabeza y obtener la máxima comodidad.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Audio nítido',
      content: 'Los modelos premium ofrecen excelente calidad de sonido con bajos profundos, agudos nítidos y medios equilibrados, mejorando tu experiencia auditiva.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento de ruido',
      content: 'Busca audífonos que ofrezcan un buen aislamiento pasivo del ruido, bloqueando el sonido ambiental durante desplazamientos o entrenamientos.',
    },
    {
      id: 3,
      product: '',
      title: 'Baja latencia',
      content: 'Los modelos Bluetooth con baja latencia aseguran que no haya retraso entre el audio y el video, ideales para ver películas o jugar.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Resistencia al agua',
      content: 'Los modelos con clasificación IPX6 resisten el sudor, la lluvia y las salpicaduras, lo que los hace fiables para cualquier tipo de actividad física.',
    },
    {
      id: 2,
      product: '',
      title: 'Construcción ligera',
      content: 'Busca materiales ligeros como aluminio o plásticos de alta calidad para garantizar comodidad durante largos períodos.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño resistente',
      content: 'La durabilidad es clave para un rendimiento duradero, especialmente si usas los audífonos al aire libre o durante actividades intensas.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Conexión inalámbrica estable',
      content: 'Busca Bluetooth 5.0 o superior para una conexión estable y con mínima interferencia.',
    },
    {
      id: 2,
      product: '',
      title: 'Alcance extendido',
      content: 'Un largo alcance inalámbrico asegura audio sin interrupciones, incluso si te mueves por la habitación o el área.',
    },
    {
      id: 3,
      product: '',
      title: 'Emparejamiento fácil',
      content: 'Asegúrate de que los audífonos sean fáciles de emparejar con tus dispositivos, con opciones de emparejamiento múltiple para cambiar entre dispositivos sin problemas.',
    },
  ]
}

// Foldable Headphones
let Foldable_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Audio Claro',
      content: 'Elige auriculares con controladores de alta calidad para asegurarte de un sonido claro y nítido para música, llamadas y medios de comunicación Communicación.',
    },
    {
      id: 2,
      product: '',
      title: 'Respuesta de Bajo',
      content: 'Considera auriculares con un bajo mejorado para una experiencia de escucha más rica, especialmente para los géneros con mucho bajo.',
    },
    {
      id: 3,
      product: '',
      title: 'Audio Equilibrado',
      content: 'Busca auriculares con un perfil de audio equilibrado, que cubra tanto las frecuencias altas como las bajas para una experiencia inmersiva.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diademas Ajustables',
      content: 'Asegúrate de que los auriculares tengan una diadema ajustable para adaptarse a diferentes tamaños de cabeza.',
    },
    {
      id: 2,
      product: '',
      title: 'Cubiertas de Oreja Acolchadas',
      content: 'Las cubiertas de oreja suaves y acolchadas ayudan a mejorar el confort, especialmente durante sesiones de escucha prolongadas.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño Ligero',
      content: 'Los auriculares plegables livianos reducen la presión en las orejas y la cabeza, ofreciendo comodidad durante un uso prolongado.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Construcción Sólida',
      content: 'Elige auriculares hechos de materiales de alta calidad como metal o plástico reforzado para asegurarte de su durabilidad.',
    },
    {
      id: 2,
      product: '',
      title: 'Diseño Plegable',
      content: 'El diseño plegable evita el daño y hace que sea fácil de almacenar cuando no se está usando.',
    },
    {
      id: 3,
      product: '',
      title: 'Resistencia al Agua y al Sudor',
      content: 'Elige modelos con una clasificación IP alta para soportar el sudor y la humedad, ideales para el uso al aire libre o para hacer ejercicio.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Conectividad Inalámbrica',
      content: 'Busca auriculares plegables con Bluetooth para tener libertad de movimiento y conexiones sin problemas.',
    },
    {
      id: 2,
      product: '',
      title: 'Opciones Cableadas',
      content: 'Algunos modelos plegables también ofrecen conectividad cableada para situaciones en las que Bluetooth no está disponible.',
    },
    {
      id: 3,
      product: '',
      title: 'Emparejamiento Multi-dispositivo',
      content: 'Considera auriculares con soporte Bluetooth multipunto para conectarse a múltiples devices a la vez.',
    },
  ]
}

// Premium Headphones
let Premium_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Tamaño y Tipo de Controlador',
      content: 'Los controladores más grandes ofrecen un bajo más profundo y un sonido más rico.',
    },
    {
      id: 2,
      product: '',
      title: 'Rango de Frecuencia',
      content: 'Un rango más amplio significa mejores tonos altos y bajos.',
    },
    {
      id: 3,
      product: '',
      title: 'Soporte de Código',
      content: 'LDAC o aptX HD aseguran un audio inalámbrico de alta fidelidad.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'ANC o Aislamiento Pasivo',
      content: 'ANC bloquea el ruido; los diseños pasivos aislan naturalmente.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajuste y Sello',
      content: 'Un sello hermético mejora el bajo y bloquea el sonido exterior.',
    },
    {
      id: 3,
      product: '',
      title: 'Prevención de Filtrado',
      content: 'Asegura la privacidad y evita molestar a los demás cercanos.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Diadema Ajustable',
      content: 'Se adapta a la forma de tu cabeza para un uso a largo plazo.',
    },
    {
      id: 2,
      product: '',
      title: 'Acolchado de Oreja',
      content: 'La espuma de memoria reduce la presión para un uso prolongado.',
    },
    {
      id: 3,
      product: '',
      title: 'Distribución de Peso',
      content: 'El diseño uniforme evita la acumulación de presión en la cabeza.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Duración de la Batería',
      content: 'Busca 20 horas o más con soporte de carga rápida.',
    },
    {
      id: 2,
      product: '',
      title: 'Resistencia al Agua',
      content: 'Los modelos con clasificación IPX pueden manejar el sudor y la lluvia fácilmente.',
    },
    {
      id: 3,
      product: '',
      title: 'Portabilidad',
      content: 'Los modelos plegables o compactos son perfectos para el uso mientras te mueves.',
    },
  ]
}

// Black Headphones
let Black_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Audio de alta fidelidad',
      content: 'Busca auriculares con certificación Hi-Res para una reproducción de sonido superior.',
    },
    {
      id: 2,
      product: '',
      title: 'Cancelación de ruido',
      content: 'Las funciones de cancelación activa de ruido garantizan una experiencia de escucha envolvente.',
    },
    {
      id: 3,
      product: '',
      title: 'Rendimiento de graves',
      content: 'Los controladores de graves mejorados ofrecen profundidad para géneros como EDM y hip-hop.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Diademas ajustables y almohadillas acolchadas para un uso prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Estructura ligera',
      content: 'Reduce la fatiga durante sesiones de escucha prolongadas.',
    },
    {
      id: 3,
      product: '',
      title: 'Ajuste seguro',
      content: 'Garantiza estabilidad durante actividades como entrenamientos o desplazamientos.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Elige modelos que ofrezcan más de 30 horas de autonomía.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'Las funciones de carga rápida brindan horas de uso con un tiempo de carga mínimo.',
    },
    {
      id: 3,
      product: '',
      title: 'Carga inalámbrica',
      content: 'Carga conveniente sin la molestia de los cables.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth 5.0 o superior',
      content: 'Garantiza conexiones inalámbricas estables y eficientes.',
    },
    {
      id: 2,
      product: '',
      title: 'Integración con aplicaciones',
      content: 'Personaliza los perfiles de sonido y los controles mediante apps dedicadas.',
    },
    {
      id: 3,
      product: '',
      title: 'Emparejamiento con múltiples dispositivos',
      content: 'Cambia sin problemas entre dispositivos sin tener que volver a emparejar.',
    },
  ]
}

// Blue Headphones
let Blue_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Audio de alta fidelidad',
      content: 'Busca auriculares con certificación Hi-Res para una reproducción de sonido superior.',
    },
    {
      id: 2,
      product: '',
      title: 'Cancelación de ruido',
      content: 'Las funciones de cancelación activa garantizan una experiencia auditiva envolvente.',
    },
    {
      id: 3,
      product: '',
      title: 'Rendimiento de graves',
      content: 'Los controladores de bajos mejorados ofrecen profundidad para géneros como EDM y hip-hop.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Diademas ajustables y almohadillas acolchadas para un uso prolongado.',
    },
    {
      id: 2,
      product: '',
      title: 'Estructura ligera',
      content: 'Reduce la fatiga durante largas sesiones de escucha.',
    },
    {
      id: 3,
      product: '',
      title: 'Ajuste seguro',
      content: 'Proporciona estabilidad durante entrenamientos o desplazamientos.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Larga duración de batería',
      content: 'Opta por modelos que ofrezcan más de 30 horas de autonomía.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida',
      content: 'La carga rápida proporciona horas de uso con poco tiempo de carga.',
    },
    {
      id: 3,
      product: '',
      title: 'Carga inalámbrica',
      content: 'Carga conveniente sin necesidad de cables.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Bluetooth 5.0 o superior',
      content: 'Conexiones inalámbricas estables y eficientes.',
    },
    {
      id: 2,
      product: '',
      title: 'Integración con aplicaciones',
      content: 'Personaliza perfiles de sonido y controles desde apps dedicadas.',
    },
    {
      id: 3,
      product: '',
      title: 'Emparejamiento multidispositivo',
      content: 'Cambia entre dispositivos sin necesidad de volver a emparejar.',
    },
  ]
}

// Pink Headphones
let Pink_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Diseño ergonómico',
      content: 'Asegura una escucha prolongada sin molestias.',
    },
    {
      id: 2,
      product: '',
      title: 'Diadema o puntas ajustables',
      content: 'Un mejor ajuste mejora el sonido y la estabilidad.',
    },
    {
      id: 3,
      product: '',
      title: 'Construcción ligera',
      content: 'Ideal para uso prolongado sin fatiga auditiva.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Respuesta de graves mejorada',
      content: 'Hace que la música se sienta rica e inmersiva.',
    },
    {
      id: 2,
      product: '',
      title: 'Aislamiento o cancelación de ruido',
      content: 'Bloquea distracciones para una escucha enfocada.',
    },
    {
      id: 3,
      product: '',
      title: 'Tecnología de llamadas claras',
      content: 'Perfecto para el trabajo remoto o llamadas en movimiento.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Compatibilidad con Bluetooth 5.3',
      content: 'Conexiones rápidas, estables y eficientes en consumo.',
    },
    {
      id: 2,
      product: '',
      title: 'Controles táctiles o con botones',
      content: 'Gestiona fácilmente volumen, llamadas y música.',
    },
    {
      id: 3,
      product: '',
      title: 'Integración con asistentes de voz',
      content: 'Control manos libres para usuarios inteligentes.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Diseño plegable o compacto',
      content: 'Fácil de transportar a cualquier lugar.',
    },
    {
      id: 2,
      product: '',
      title: 'Durabilidad del color',
      content: 'El tono rosa se mantiene vibrante con el tiempo.',
    },
    {
      id: 3,
      product: '',
      title: 'Estuche de viaje incluido',
      content: 'Mayor comodidad y protección.',
    },
  ]
}

// White Headphones
let White_Headphones_list = {
  answer_type1: [
    {
      id: 1,
      product: '',
      title: 'Ajuste seguro',
      content: 'Evita que se deslicen durante el movimiento.',
    },
    {
      id: 2,
      product: '',
      title: 'Ajustabilidad',
      content: 'Diadema o puntas personalizables.',
    },
    {
      id: 3,
      product: '',
      title: 'Diseño ligero',
      content: 'Evita la fatiga con el uso prolongado.',
    },
  ],

  answer_type2: [
    {
      id: 1,
      product: '',
      title: 'Rendimiento del controlador',
      content: 'Graves profundos y agudos claros.',
    },
    {
      id: 2,
      product: '',
      title: 'ANC o aislamiento',
      content: 'Elige según el entorno de uso.',
    },
    {
      id: 3,
      product: '',
      title: 'Compatibilidad con códecs',
      content: 'Asegúrate de que incluya códecs Bluetooth de alta calidad.',
    },
  ],

  answer_type3: [
    {
      id: 1,
      product: '',
      title: 'Materiales de construcción',
      content: 'Aluminio o plásticos de calidad resisten el desgaste.',
    },
    {
      id: 2,
      product: '',
      title: 'Plegables',
      content: 'Fáciles de guardar y perfectos para viajar.',
    },
    {
      id: 3,
      product: '',
      title: 'Clasificación IP',
      content: 'Busca resistencia a salpicaduras o sudor.',
    },
  ],

  answer_type4: [
    {
      id: 1,
      product: '',
      title: 'Batería de larga duración',
      content: 'Evita recargas frecuentes.',
    },
    {
      id: 2,
      product: '',
      title: 'Carga rápida o inalámbrica',
      content: 'Opciones prácticas de carga.',
    },
    {
      id: 3,
      product: '',
      title: 'Bluetooth estable',
      content: 'Versión 5.x para audio sin retrasos.',
    },
  ]
}


function get_scenario_list(typeNmae){
  let arrData = []
  if(typeNmae == 'Leisure'){
    arrData = Leisure_list
  }else if(typeNmae == 'Travel'){
    arrData = Travel_list
  }else if(typeNmae == 'Fitness'){
    arrData = Fitness_list
  }else if(typeNmae == 'Work'){
    arrData = Work_list
  }else if(typeNmae == 'superior_sound_quality'){
    arrData = superior_sound_quality_list
  }else if(typeNmae == 'noise_canceling'){
    arrData = noise_canceling_list
  }else if(typeNmae == 'long_lasting_battery'){
    arrData = long_lasting_battery_list
  }else if(typeNmae == 'comfortable_fit'){
    arrData = comfortable_fit_list
  }else if(typeNmae == 'Work_Headphones'){
    arrData = Work_Headphones_list
  }else if(typeNmae == 'Travel_Headphones'){
    arrData = Travel_Headphones_list
  }

  else if(typeNmae == 'Over_Ear_Headphones'){
    arrData = Over_Ear_Headphones_list
  }else if(typeNmae == 'Waterproof_Earbuds'){
    arrData = Waterproof_Earbuds_list
  }else if(typeNmae == 'Open_Ear_Headphones'){
    arrData = Open_Ear_Headphones_list
  }else if(typeNmae == 'Ture_Wireless_Earbuds'){
    arrData = Ture_Wireless_Earbuds_list
  }else if(typeNmae == 'Hi_Res_Audio_Headphones'){
    arrData = Hi_Res_Audio_Headphones_list
  }else if(typeNmae == 'Comfortable_Headphones'){
    arrData = Comfortable_Headphones_list
  }else if(typeNmae == 'Gaming_Headphones'){
    arrData = Gaming_Headphones_list
  }else if(typeNmae == 'Long_Battery_Life_Earbuds'){
    arrData = Long_Battery_Life_Earbuds_list
  }else if(typeNmae == 'Translate_Earbuds'){
    arrData = Translate_Earbuds_list
  }else if(typeNmae == 'Sleep_Headphones'){
    arrData = Sleep_Headphones_list
  }else if(typeNmae == 'Kids_Headphones'){
    arrData = Kids_Headphones_list
  }else if(typeNmae == 'IPX7_Waterproof_Earbuds'){
    arrData = IPX7_Waterproof_Earbuds_list
  }else if(typeNmae == 'IPX8_Waterproof_Earbuds'){
    arrData = IPX8_Waterproof_Earbuds_list
  }else if(typeNmae == 'IPX6_Earbuds'){
    arrData = IPX6_Earbuds_list
  }
  else if(typeNmae == 'Behind_the_Ear_Headphones'){
    arrData = Behind_the_Ear_Headphones_list
  }else if(typeNmae == 'Foldable_Headphones'){
    arrData = Foldable_Headphones_list
  }else if(typeNmae == 'Premium_Headphones'){
    arrData = Premium_Headphones_list
  }

  else if(typeNmae == 'Black_Headphones'){
    arrData = Black_Headphones_list
  }else if(typeNmae == 'Blue_Headphones'){
    arrData = Blue_Headphones_list
  }else if(typeNmae == 'Pink_Headphones'){
    arrData = Pink_Headphones_list
  }else if(typeNmae == 'White_Headphones'){
    arrData = White_Headphones_list
  }
  return arrData
}